import "./instrumental.scss";




export default function Instrumental() {


    return (
        <div className="instrumental" id="instrumental">
            <h1 className="titulo">INSTRUMENTAL</h1>

            <div className="cards">

                <div className="card" >
                    <img src="/assets/img/gnss.png" className="instrumento" />
                    <div className="card-body">
                        <h5 className="card-title">Equipo GNSS</h5>
                        <p className="card-text">CHCNAV iBase + i73 Plus</p>
                    </div>
                </div>

                <div className="card" >
                    <img src="/assets/img/estacionTotal.png" className="instrumento" />
                    <div className="card-body">
                        <h5 className="card-title">Estacion Total</h5>
                        <p className="card-text">SOUTH N6+</p>
                    </div>
                </div>

                <div className="card" >
                    <img src="/assets/img/nivelOptico.png" className="instrumento" />
                    <div className="card-body">
                        <h5 className="card-title">Nivel Optico</h5>
                        <p className="card-text">KOLIDA KL-C32</p>
                    </div>
                </div>

                <div className="card" >
                    <img src="/assets/img/distanciometro.png" className="instrumento" />
                    <div className="card-body">
                        <h5 className="card-title">Distanciometro</h5>
                        <p className="card-text">KOLIDA PD-520</p>
                    </div>
                </div>


            </div>

        </div>
    );
}
